<div *ngIf="subview != 'cardholderSelected'" class="card card-nc">
  <div class="card-heading">
    <div class="card-title search-header">
      Ship User Maintenance - Find CardHolder
    </div>
  </div>
  <div style="padding-top: 30px" class="card-body">
    <form
      class=""
      #cardHolderSearchForm="ngForm"
      [formGroup]="cardholdersSearchForm"
      name="cardholdersSearchForm"
      novalidate
      angular-Validator
    >
      <div class="form-group row">
        <div class="col-md-6">
          <input
            type="text"
            formControlName="firstParameter"
            name="firstParameter"
            id="firstParameter"
            class="form-control input-sm searhBoxheight"
            placeholder="Enter closed loop number"
            autocomplete="off"
          />
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !cardholdersSearchForm.get('firstParameter').valid &&
              cardholdersSearchForm.get('firstParameter').touched &&
              cardholdersSearchForm.get('firstParameter').errors
            "
          >
            You must enter a valid 16 digit card number
          </span>
        </div>

        <div class="col-md-1">
          <button
            type="submit"
            [disabled]="!cardholdersSearchForm.valid"
            id="searchButton"
            (click)="submitCardholderSearch()"
            class="form-group btn btn-nc pull-right"
          >
            SEARCH <i [ngClass]="search_btn_spinner"></i>
          </button>
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
<div [ngSwitch]="subview">
  <div *ngSwitchCase="'spinner'">
    <div class="row">
      <div class="col-md-offset-6">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'noSearchParameters'">
    <div class="searchResults">
      <div class="row searchResultsRow">Please enter search criteria.</div>
    </div>
  </div>
  <div *ngSwitchCase="'noResults'">
    <div class="searchResults">
      <div class="row searchResultsRow">No results found.</div>
    </div>
  </div>
  <div *ngSwitchCase="'results'" class="searchResults">
    <app-search-results
      (cardholderSelected)="showCardholder($event)"
      [profileSearchResults]="searchResults"
    ></app-search-results>
  </div>
  <div *ngIf="subview == 'cardholderSelected'" class="card card-nc">
    <div class="card-heading">CREATE/MAINTAIN SHIP USER</div>
    <div class="card-body p-4">
      <div class="card-body">
        <strong>Name: </strong>
        {{ searchResults[0].name }}
        &nbsp;&nbsp;
        <strong>Card Number: </strong>
        {{ searchResults[0].cardNum }}
      </div>
      <div class="card-body p-4">
        <app-ship-user-form
          [userCardNumber]="selectedCardNumber"
          *ngIf="selectedCardNumber != ''"
          (onUserEntryCancelled)="userEntryClose()"
          (onUserEntrySuccess)="userEntryClose()"
        ></app-ship-user-form>
      </div>
    </div>
  </div>
</div>
